<div class="modal-backdrop" (click)="onBackdropClick($event)">
  <div class="modal-container">
    <!-- Modal Header -->
    <div class="modal-header">
      <h2 class="modal-title">{{ getTranslatedField(auction.title) }}</h2>
      <button class="close-button" (click)="onClose()" aria-label="Close">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 6L6 18M6 6L18 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <div class="info-section">
        @if (auction.consignor) {
          <div class="info-item">
            <label>{{ "auctions_calendar.modal.consignor" | translate }}</label>
            <p>{{ getTranslatedField(auction.consignor) }}</p>
          </div>
        }

        @if (auction.email) {
          <div class="info-item">
            <label>{{ "auctions_calendar.modal.email" | translate }}</label>
            <p>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.66669 2.66669H13.3334C14.0667 2.66669 14.6667 3.26669 14.6667 4.00002V12C14.6667 12.7334 14.0667 13.3334 13.3334 13.3334H2.66669C1.93335 13.3334 1.33335 12.7334 1.33335 12V4.00002C1.33335 3.26669 1.93335 2.66669 2.66669 2.66669Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.6667 4L8.00002 8.66667L1.33335 4"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <a [href]="'mailto:' + auction.email">{{ auction.email }}</a>
            </p>
          </div>
        }

        @if (auction.phone) {
          <div class="info-item">
            <label>{{ "auctions_calendar.modal.phone" | translate }}</label>
            <p>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.6667 11.28V13.28C14.6675 13.4657 14.6294 13.6494 14.555 13.8195C14.4807 13.9897 14.3716 14.1424 14.2348 14.2679C14.0979 14.3934 13.9364 14.489 13.7605 14.5485C13.5847 14.608 13.3983 14.63 13.2134 14.6133C11.1619 14.3904 9.19137 13.6894 7.46002 12.5667C5.84919 11.5431 4.48353 10.1774 3.46002 8.56665C2.33336 6.82745 1.6322 4.84731 1.41335 2.78665C1.39671 2.60229 1.41862 2.41649 1.4777 2.24107C1.53679 2.06564 1.63175 1.90444 1.75655 1.76773C1.88134 1.63102 2.03324 1.52179 2.20256 1.44708C2.37189 1.37237 2.55493 1.33374 2.74002 1.33332H4.74002C5.06357 1.33013 5.37723 1.4447 5.62248 1.65568C5.86773 1.86666 6.02804 2.15961 6.07335 2.47998C6.15779 3.12003 6.31434 3.74847 6.54002 4.35332C6.62974 4.59193 6.64915 4.85126 6.59597 5.10058C6.5428 5.34989 6.41928 5.57872 6.24002 5.75998L5.39335 6.60665C6.34241 8.27568 7.72432 9.65758 9.39335 10.6067L10.24 9.75998C10.4213 9.58072 10.6501 9.4572 10.8994 9.40403C11.1488 9.35086 11.4081 9.37027 11.6467 9.45998C12.2515 9.68567 12.88 9.84221 13.52 9.92665C13.8439 9.97234 14.1396 10.1355 14.3511 10.385C14.5625 10.6345 14.6748 10.953 14.6667 11.28Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <a dir="ltr" [href]="'tel:' + auction.phone">{{
                auction.phone
              }}</a>
            </p>
          </div>
        }

        @if (auction.location) {
          <div class="info-item">
            <label>{{ "auctions_calendar.modal.location" | translate }}</label>
            <p>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 8.5C9.10457 8.5 10 7.60457 10 6.5C10 5.39543 9.10457 4.5 8 4.5C6.89543 4.5 6 5.39543 6 6.5C6 7.60457 6.89543 8.5 8 8.5Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8 1.5C6.4087 1.5 4.88258 2.13214 3.75736 3.25736C2.63214 4.38258 2 5.9087 2 7.5C2 9.082 2.474 10.248 3.6 11.5L8 15.5L12.4 11.5C13.526 10.248 14 9.082 14 7.5C14 5.9087 13.3679 4.38258 12.2426 3.25736C11.1174 2.13214 9.5913 1.5 8 1.5Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              {{ getTranslatedField(auction.location) }}
            </p>
          </div>
        }

        @if (auction.previewDate) {
          <div class="info-item">
            <label>{{
              "auctions_calendar.modal.preview_date" | translate
            }}</label>
            <p>{{ formatDate(auction.previewDate) }}</p>
          </div>
        }

        @if (auction.time) {
          <div class="info-item">
            <label>{{ "auctions_calendar.modal.time" | translate }}</label>
            <p>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8 4V8L10.5 9.5"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              {{ formatTime(auction.time) }}
            </p>
          </div>
        }

        @if (auction.startDate) {
          <div class="info-item">
            <label>{{
              "auctions_calendar.modal.start_date" | translate
            }}</label>
            <p>{{ formatDate(auction.startDate) }}</p>
          </div>
        }

        @if (auction.endDate) {
          <div class="info-item">
            <label>{{ "auctions_calendar.modal.end_date" | translate }}</label>
            <p>{{ formatDate(auction.endDate) }}</p>
          </div>
        }

        @if (auction.description) {
          <div class="info-item full-width">
            <label>{{
              "auctions_calendar.modal.description" | translate
            }}</label>
            <p>{{ getTranslatedField(auction.description) }}</p>
          </div>
        }

        <!-- Calendar Section -->
        <div class="calendar-section full-width">
          <div class="divider"></div>
          <h3 class="calendar-heading">
            {{ "auctions_calendar.modal.add_to_calendar" | translate }}
          </h3>
          <div class="calendar-button-wrapper">
            <add-to-calendar-button
              [attr.name]="getTranslatedField(auction.title)"
              [attr.location]="getTranslatedField(auction.location)"
              [attr.startDate]="getCalendarStartDate()"
              [attr.endDate]="getCalendarEndDate()"
              [attr.description]="getCalendarDescription()"
              [attr.language]="calendarLanguage"
              options="'Apple','Google','Outlook.com','Yahoo','iCal'"
              timeZone="currentBrowser"
              lightMode="bodyScheme"
              size="3"
              buttonStyle="date"
              [attr.label]="addToCalendarButtonLabel"
            ></add-to-calendar-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <button class="btn-secondary" (click)="onClose()">
        {{ "auctions_calendar.modal.close" | translate }}
      </button>
      @if (auction.auctionUrl) {
        <button class="btn-primary" (click)="openAuctionUrl()">
          {{ "auctions_calendar.modal.open_auction" | translate }}
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 8.66667V12.6667C12 13.0203 11.8595 13.3594 11.6095 13.6095C11.3594 13.8595 11.0203 14 10.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V5.33333C2 4.97971 2.14048 4.64057 2.39052 4.39052C2.64057 4.14048 2.97971 4 3.33333 4H7.33333"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10 2H14V6"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.66669 9.33333L14 2"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      }
    </div>
  </div>
</div>
